module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ad93ad726651f5aa12f59233be08e436.png";